import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api } from "../lib/api";
import SEO from "../components/SEO";
import { CheckCircle2, Stethoscope, ArrowRight } from "lucide-react";

export default function CityPage() {
  const { slug } = useParams();
  const [city, setCity] = useState(null);
  useEffect(() => {
    api.get(`/cities/${slug}`).then(({ data }) => setCity(data)).catch(() => {});
  }, [slug]);

  if (!city) return <div className="hc-container py-20 text-center text-slate-500">Loading…</div>;
  const title = `Cochlear Implant Surgery in ${city.city}`;

  return (
    <>
      <SEO title={title} description={city.intro} />
      <section className="bg-gradient-to-br from-[#F0F9FF] via-white to-[#ECFDF5] py-14">
        <div className="hc-container max-w-4xl">
          <h1 className="font-serif text-[2.25rem] md:text-[3rem] font-semibold leading-[1.08] text-slate-900">{title}</h1>
          <p className="mt-5 text-slate-700 text-[1.05rem]">{city.intro}</p>
        </div>
      </section>

      <section className="hc-container py-12 grid lg:grid-cols-3 gap-8">
        <div className="lg:col-span-2 space-y-6">
          <div className="card-hc">
            <h2 className="font-serif text-xl font-semibold text-slate-900">Cost range</h2>
            <p className="mt-2 text-slate-700 text-[16px]">{city.cost_range}</p>
          </div>
          <div className="card-hc">
            <h2 className="font-serif text-xl font-semibold text-slate-900">Funding schemes available</h2>
            <ul className="mt-3 space-y-2">
              {city.schemes?.map((s) => <li key={s} className="flex gap-2 text-slate-700"><CheckCircle2 size={18} className="text-[#0F766E] mt-1 shrink-0" />{s}</li>)}
            </ul>
            <Link to="/cochlear-implant-cost-funding" className="mt-4 btn-secondary inline-flex">Explore funding</Link>
          </div>
        </div>
        <aside className="space-y-5">
          <div className="card-hc">
            <span className="w-11 h-11 rounded-xl bg-[#ECFDF5] flex items-center justify-center text-[#0F766E] mb-3">
              <Stethoscope size={20} />
            </span>
            <div className="font-serif text-lg font-semibold text-slate-900">Consult a CI expert</div>
            <p className="mt-2 text-slate-600 text-[14.5px] leading-relaxed">
              Dr. Sanjay Sachdeva — 35+ years in cochlear implant surgery, Delhi. Consultations available for families across India.
            </p>
            <Link to="/doctors" className="mt-4 inline-flex items-center gap-1 text-[#0369A1] font-semibold text-sm">
              View profile <ArrowRight size={14} />
            </Link>
          </div>
        </aside>
      </section>
    </>
  );
}
